module.exports = __webpack_public_path__ + "img/icon_dianpu_XIAOHS.c70b24cd.png";